export default __webpack_public_path__ + "static/media/19.533ebf87.jpg";